// extracted by mini-css-extract-plugin
module.exports = {"reasons-list":"status-badge_reasons-list__1cP6_"};